<template>
  <!-- 明细列表 -->
  <el-dialog :title="title" :visible="visible" :show-close="false">
    <div>
      <el-form :inline="true" @submit.native.prevent :model="searchForm">
        <el-form-item>
          <el-select
            v-model="searchForm.company_ids"
            multiple
            placeholder="选择科目"
            @change="search(searchForm)"
            style="width:250px;">
            <el-option
              v-for="item in companyList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            placeholder="搜索单据编号"
            v-model="searchForm.query"
            prefix-icon="el-icon-search"
            clearable
            @input="inputSearch(searchForm)">
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <!--
    <el-alert
      title="这里只显示可返现的单据，没有显示已作废和已返现的单据"
      type="error"
      :closable="false">
    </el-alert>
    <br/>
    -->
    <el-table
      :data="list"
      stripe
      border
      style="width:100%"
      max-height="350"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        :selectable="handleSelectable">
      </el-table-column>
      <el-table-column
        prop="company_name"
        label="所属科目"
        width="100">
      </el-table-column>
      <el-table-column
        prop="bill_no"
        label="单据编号"
        width="120">
      </el-table-column>
      <el-table-column
        prop="fee"
        label="应收金额"
        width="80">
      </el-table-column>
      <el-table-column
        prop="pay_total"
        label="实收金额"
        width="80">
      </el-table-column>
      <el-table-column
        prop="return_fee"
        label="符合返现条件的金额"
        width="150">
      </el-table-column>
      <el-table-column
        prop="ret_rate"
        label="返现率"
        width="70">
      </el-table-column>
      <el-table-column
        label="可返金额"
        width="80">
        <template slot-scope="scope">
          {{ Math.floor(scope.row.return_fee * scope.row.ret_rate) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="start_time"
        label="开始时间"
        width="160">
      </el-table-column>
      <el-table-column
        prop="end_time"
        label="结束时间"
        width="160">
      </el-table-column>
      <el-table-column
        prop="price_type"
        label="计费方式"
        width="140">
      </el-table-column>
      <el-table-column
        prop="fee_discount"
        label="优惠"
        width="70">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        width="150">
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="pageSizeChange"
      @current-change="pageChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next"
      :total="total">
    </el-pagination>
    <hr style="margin-bottom:20px"/>
    <el-form :model="finForm" ref="finForm" :rules="finFormRules" label-width="120px" v-if="returnMoney > 0">
      <el-form-item label="已选择的单据">
        <el-tag
          v-for="row in selectRows"
          :key="row.bill_no"
          closable
          @close="removeRows(row)">
          {{ row.bill_no }}
        </el-tag>
      </el-form-item>
      <el-form-item label="支出项目" prop="fin_item">
        <el-col :span="11">
          <el-select v-model="finForm.fin_item" placeholder="请选择项目" style="width:100%">
            <el-option v-for="i in finItemList" :key="i.id" :label="i.item_name" :value="i.item_name"></el-option>
          </el-select>
        </el-col>
        <el-col :span="2" style="text-align:center;">-</el-col>
        <el-col :span="11">
          <el-input v-model="finForm.fin_no" placeholder="凭证号(可以不填)" style="width:100%"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="支出金额" prop="fin_money">
        <el-col :span="11">
          <el-input v-model.number="finForm.fin_money" disabled></el-input>
        </el-col>
        <el-col :span="2" style="text-align:center;">-</el-col>
        <el-col :span="11">
          <el-input v-model="finForm.fin_person" placeholder="收款人"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="支付方式" prop="pay_type">
        <el-col :span="11">
          <el-select v-model="finForm.pay_type" placeholder="请选择支付方式" @change="payTypeChange" style="width:100%">
            <el-option label="现金" value="现金"></el-option>
            <el-option label="支付宝" value="支付宝"></el-option>
            <el-option label="微信支付" value="微信支付"></el-option>
            <el-option label="刷卡" value="刷卡"></el-option>
            <el-option label="转账" value="转账"></el-option>
          </el-select>
        </el-col>
        <el-col :span="2" style="text-align:center;">-</el-col>
        <el-col :span="11">
          <el-form-item prop="fin_account">
            <el-select v-model="finForm.fin_account" placeholder="请选择账户" style="width:100%">
              <el-option v-for="i in accountListFilter" :key="i.id" :label="i.name" :value="i.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="finForm.remark" type="textarea" autosize placeholder="备注(可以不填)"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <span style="font-size:14px;color:green;">已选择{{ selectRows.length }}张单据,返现合计{{ returnMoney }}元&nbsp;&nbsp;</span>
      <el-button type="primary" @click="commit" :loading="commiting" :disabled="returnMoney == 0">确定返现{{ returnMoney }}元</el-button>
      <el-button @click="close">关闭窗口</el-button>
    </div>
  </el-dialog>
</template>

<script>
import qs from 'qs'
import _ from 'lodash'
export default {
  props: {
    coach: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    title: {
      type: String,
      default: '请选择要返现的单据'
    },
    user: Object
  },
  data () {
    return {
      list: [],
      loading: false,
      currentPage: 1,
      pageSize: 100,
      total: 0,
      commiting: false,
      selectRows: [],
      finForm: {
        fin_type: '0',
        fin_item: '',
        pay_type: '现金',
        fin_account: 0,
        fin_money: 0,
        fin_person: '',
        fin_no: '',
        remark: ''
      },
      finFormRules: {
        fin_item: [
          { required: true, message: '请选择项目', trigger: 'blur' }
        ],
        fin_account: [
          { required: true, message: '请选择账户', trigger: 'blur' }
        ],
        fin_money: [
          { required: true, message: '请输入金额', trigger: 'blur' }
        ]
      },
      finItemList: [],
      accountList: [],
      params: {},
      searchForm: {
        query: '',
        company_ids: []
      },
      companyList: []
    }
  },
  computed: {
    returnMoney () {
      let t = 0
      for (let i = 0; i < this.selectRows.length; i++) {
        t += Math.floor(parseFloat((this.selectRows[i].return_fee * this.selectRows[i].ret_rate).toPrecision(12)))
      }
      return t
    },
    accountListFilter () {
      if (this.finForm.pay_type === '现金') {
        return this.accountList.filter(i => i.account_type === '现金')
      } else if (this.finForm.pay_type === '支付宝') {
        return this.accountList.filter(i => i.account_type === '支付宝')
      } else if (this.finForm.pay_type === '微信支付') {
        return this.accountList.filter(i => i.account_type === '微信')
      } else if (this.finForm.pay_type === '刷卡') {
        return this.accountList.filter(i => i.account_type === '银行')
      } else if (this.finForm.pay_type === '转账') {
        return this.accountList.filter(i => i.account_type === '银行')
      } else {
        return []
      }
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.fetchList()
      }
    },
    returnMoney (val) {
      this.finForm.fin_money = val
    },
    selectRows (val) {
      if (val && val.length > 0) {
        this.finForm.remark = '单据编号:' + val.map(r => r.bill_no)
      }
    },
    coach (val) {
      this.finForm.fin_person = val && val.coach_name
    }
  },
  mounted () {
    this.fetchCompanyList()
    this.fetchFinItemList()
    this.fetchAccountList()
  },
  methods: {
    fetchList () {
      this.loading = true
      this.$http.get('/dbapi/bill_list', {
        params: {
          ...this.params,
          coach_id: this.coach.coach_id,
          status: '正常',
          return_status: '未返现',
          start: (this.currentPage - 1) * this.pageSize,
          limit: this.pageSize
        },
        paramsSerializer: function(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        }
      }).then(response => {
        if (response.data.success) {
          this.list = response.data.list
          this.total = response.data.total
        } else {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      })
    },
    search (params) { // 搜索
      for (let p in params) {
        if (!params[p]) {
          delete params[p]
        }
      }
      this.params = params
      this.currentPage = 1
      this.fetchList()
    },
    inputSearch: _.debounce(function (params) {
      this.search(params)
    }, 500), // 输入中止500毫秒后触发搜索,防止密集输入
    fetchCompanyList() {
      // 获取考场列表
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
          this.searchForm.company_ids = this.companyList.map(c => c.value)
        }
      })
    },
    fetchFinItemList () {
      this.$http.get('/dbapi/fin_item_combo').then(response => {
        if (response.data.success) {
          this.finItemList = response.data.list
          for (var i = 0; i < this.finItemList.length; i++) {
            if (this.user.group_id == 1) {
              if (this.finItemList[i].item_name.indexOf('押金') >= 0) {
                this.finForm.fin_item = this.finItemList[i].item_name
                break;
              }
            } else {
              if (this.finItemList[i].item_name.indexOf('返点') >= 0 || this.finItemList[i].item_name.indexOf('返现') >= 0) {
                this.finForm.fin_item = this.finItemList[i].item_name
                break;
              }
            }
          }
        }
      })
    },
    fetchAccountList () {
      this.$http.get('/dbapi/fin_account_combo').then(response => {
        if (response.data.success) {
          this.accountList = response.data.list
          for (var i = 0; i < this.accountList.length; i++) {
            if (this.accountList[i].account_type === '现金') {
              this.finForm.fin_account = this.accountList[i].id
              break;
            }
          }
        }
      })
    },
    payTypeChange () {
      if (this.accountListFilter.length > 0) {
        this.finForm.fin_account = this.accountListFilter[0].id
      }
    },
    handleSelectionChange (rows) {
      for (let i = 0; i < rows.length; i++) {
        if (this.selectRows.filter(r => rows[i].bill_no == r.bill_no) == 0) {
          this.selectRows.push(rows[i])
        }
      }
    },
    removeRows (row) {
      this.selectRows.splice(this.selectRows.indexOf(row), 1)
    },
    handleSelectable (row, index) {
      if (row.status !== '正常') {
        return false
      } 
      if (row.pay_status !== '已支付') {
        return false
      } 
      if (row.return_status !== '未返现') {
        return false
      } 
      if (row.return_fee <= 0) {
        return false
      }
      if (row.fee_discount > 0) {
        return false
      }
      return true
    },
    pageChange (val) {
      this.currentPage = val
      this.fetchList()
    },
    pageSizeChange (val) {
      this.pageSize = val
      this.fetchList()
    },
    close () {
      this.selectRows = []
      this.$emit('close')
    },
    tableRowClassName ({row, rowIndex}) {
      if (row.status !== '正常' || row.pay_status !== '已支付' || row.return_fee <= 0 || row.fee_discount > 0) {
        return 'row-red'
      } else if (row.return_status === '已返现') {
        return 'row-green'
      } else {
        return ''
      }
    },
    commit: _.throttle(
      function () {
        if (this.selectRows.length === 0) {
          return this.$message({
            type: 'error',
            message: '请选择要返现的单据'
          })
        }
        this.$refs.finForm.validate(valid => {
          if (valid) {
            this.commiting = true
            this.$http.post('/dbapi/return_cash', {
              ids: this.selectRows.map(r => r.id),
              ...this.finForm
            }).then(response => {
              this.commiting = false
              if (response.data.success) {
                this.selectRows = []
                this.fetchList()
                this.$message({
                  type: 'success',
                  message: '操作成功'
                })
                this.$confirm('是否要现在打印支出证明单?', '提示', {
                  confirmButtonText: '现在打印',
                  cancelButtonText: '稍后打印',
                  type: 'warning'
                }).then(() => {
                  let url = '/expend_print'
                  if ([1, 10, 16, 23, 27].indexOf(this.user.group_id) >= 0) {
                    url = '/expend_print_1'
                  }
                  if ([2, 8].indexOf(this.user.group_id) >= 0) {
                    url = '/expend_print_blank'
                  }
                  window.open(this.$http.receiptBaseUrl + url + '?id=' + response.data.insertId + '&token=' + localStorage.getItem('kaochang.token'))
                })
              } else {
                this.$message({
                  type: 'error',
                  message: response.data.message
                })
              }
            })
          }
        })
      },
      2000
    )
  }
}
</script>

<style>
.el-tag+.el-tag {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/return/ReturnDialog.vue